/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCommentCheck} from '@fortawesome/pro-duotone-svg-icons';

const AdoptionTypeIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCommentCheck} {...props} />
);

export default AdoptionTypeIcon;
